// extracted by mini-css-extract-plugin
module.exports = {"root":"diag_root__3c6k-","touchArea":"diag_touchArea__1X2xC"};